import { FC, PropsWithChildren } from 'react';

export const Condition: FC<PropsWithChildren<{ when: boolean }>> = ({
  when,
  children,
}) => (when && children ? <>{children}</> : null);
